var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavBar'),_c('div',{staticClass:"container mx-auto text-center"},[_c('h2',{staticClass:"text-muted heading"},[_vm._v("QR Codes")]),_c('a',{staticClass:"btn btn-primary",attrs:{"href":'https://' + _vm.WEBAPP_URL + '/#/auth/signIn?redirect=' + _vm.APP_URL}},[_vm._v("Sign in")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }